import { API_CUSTOMER_MENU_URL } from '@/constants/config';
import { DetailedPosition } from '@/interfaces/Menu';
import { fetch } from '@/utils/fetch';

export const getPositionDetails = (
  menuId: string,
  positionId: string,
  language: string
): Promise<DetailedPosition> =>
  fetch
    .get<DetailedPosition>(
      `${API_CUSTOMER_MENU_URL}/branch-menus/${menuId}/positions/${positionId}?language=${language}`
    )
    .then(response => response.data);
